import React from 'react';
import Image from '../Image/image.jsx';
const BtnSelect = (props) => {
  return (
    <div className='btn-select-container'>
      <button className={`btn-select ${props.border}`} onClick={props.onClick}>
        {props?.imgElement && <span className='btn-select-img'>{props?.imgElement}</span>}
        {props?.icon && <Image src={props?.icon} alt='icon' className='btn-select-text-icon' />}
        <span className='btn-select-text'>{props.text}</span>
      </button>
    </div>
  );
};

export default BtnSelect;
